<template>
  <div ref="toggleView" :style="{height: `${minHeight/100}rem`}" class="toggle-view">
    <slot></slot>
    <div class="align jus icon-contain" @click.stop="send()" :style="{right: turnRight, height: `${minHeight/100}rem`}">
      <Icon v-if="!toggleIcon" type="icon" class="icon" size=".3rem" :style="`transform: rotate(${more?'-90':'90'}deg)`"></Icon>
      <img v-else :src="toggleIcon" class="yellow-car" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      minHeight: {
        type: Number,
        default: 80
      },
      turnRight: {
        type: String,
        default: '0'
      },
      loading: {
        type: Boolean,
        default: false
      },
      toggleIcon: [String, Object],
      moreClickSpace: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        more: false
      }
    },
    methods: {
      setStyle(val) {
        this.$refs.toggleView.style.height = val
      },
      moreClick() {
        if(this.moreClickSpace) {
          this.send()
        }
      },
      send() {
        if(!this.loading) {
          this.toggleMore()
        }else {
          this.$emit('toggleHide')
        }
      },
      toggleMore() {
        if(this.loading) {
          this.$toast.clear()
        }
        this.more = !this.more
        let memoMore = this.$refs.toggleView
        let documentWidth = document.body.clientWidth
        if (!this.more) {
          memoMore.style.height = `${this.minHeight/100}rem`
        } else {
          memoMore.style.height = 'auto'
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .toggle-view {
    overflow: hidden;
    transition: all .3s linear;
    position: relative;
    .icon-contain {
      position: absolute;
      right: 0;
      top: 0;
      height: 0.5rem;
      width: 0.5rem;
      .icon {
        transition: all .3s linear;
      }
    }
    .yellow-car {
      height: 0.4rem;
      width: 0.4rem;
    }
  }
</style>